// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UniversalProductModal_overlay__CYJXt{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,.45);
  display:flex;
  align-items:center;
  justify-content:center;
  padding:14px;
  z-index:9999;
}

.UniversalProductModal_modal__doWhy{
  width:min(360px, 94vw);     /* ✅ меньше */
  background:#fff;
  border-radius:14px;
  box-shadow:0 18px 50px rgba(0,0,0,.22);
  padding:12px;
  border:1px solid rgba(0,0,0,.06);
}

.UniversalProductModal_header__LTQvV{
  display:flex;
  align-items:center;
  justify-content:space-between;
  gap:10px;
  padding:4px 4px 10px 4px;
}

.UniversalProductModal_title__TxkF4{
  font-size:16px;
  font-weight:800;
  color:#111;
}

.UniversalProductModal_closeBtn__dkABv{
  width:34px;
  height:34px;
  border-radius:10px;
  border:1px solid rgba(0,0,0,.10);
  background:#fff;
  cursor:pointer;
  display:grid;
  place-items:center;
  color:#111;
}
.UniversalProductModal_closeBtn__dkABv:hover{ background:rgba(0,0,0,.04); }

.UniversalProductModal_field__ohGAE{
  margin-bottom:10px;
}

.UniversalProductModal_fieldBox__DdcWM{
  display:flex;
  align-items:center;
  gap:10px;
  border:1px solid rgba(0,0,0,.12);
  border-radius:12px;
  padding:10px 10px 10px 12px;
  background:#fff;
}

.UniversalProductModal_fieldBox__DdcWM:focus-within{
  border-color:rgba(29,135,82,.70);
  box-shadow:0 0 0 4px rgba(29,135,82,.10);
}

.UniversalProductModal_priceInput__5Glxw{
  flex:1 1;
  border:0;
  outline:0;
  background:transparent;
  font-size:22px;
  font-weight:900;
  color:#111;
  text-align:center; /* ✅ центр суммы */
  line-height:1;
}

.UniversalProductModal_textInput__8QmoN{
  flex:1 1;
  border:0;
  outline:0;
  background:transparent;
  font-size:14px;
  color:#111;
}

.UniversalProductModal_textInput__8QmoN::placeholder{
  color:rgba(0,0,0,.45);
}

.UniversalProductModal_iconBtn__DCn6q{
  width:34px;
  height:34px;
  border-radius:10px;
  border:0;
  background:rgba(29,135,82,.12);
  color:rgba(29,135,82,1);
  cursor:pointer;
  display:grid;
  place-items:center;
}
.UniversalProductModal_iconBtn__DCn6q:hover{ filter:brightness(.95); }

.UniversalProductModal_iconStatic__MWm30{
  width:34px;
  height:34px;
  border-radius:10px;
  background:rgba(0,0,0,.06);
  color:rgba(0,0,0,.72);
  display:grid;
  place-items:center;
}

.UniversalProductModal_keypad__CWGG5{
  display:grid;
  grid-template-columns:repeat(3, 1fr);
  gap:10px;
  margin:12px 0 14px;
}

.UniversalProductModal_keyBtn__GaRRc{
  height:50px;              /* ✅ ниже */
  border-radius:12px;
  border:1px solid rgba(0,0,0,.10);
  background:rgba(0,0,0,.03);
  cursor:pointer;
  display:grid;             /* ✅ центр символов */
  place-items:center;
  font-size:18px;
  font-weight:900;
  color:#111;
  -webkit-user-select:none;
          user-select:none;
}

.UniversalProductModal_keyBtn__GaRRc:hover{
  background:rgba(29,135,82,.10);
  border-color:rgba(29,135,82,.25);
}

.UniversalProductModal_keyBtn__GaRRc:active{ transform:translateY(1px); }

.UniversalProductModal_keyBtnBackspace__kcMNu{
  background:rgba(0,0,0,.06);
}

.UniversalProductModal_actionsRow__PJmJZ{
  display:grid;
  grid-template-columns:1fr 1fr;
  gap:10px;
  margin-bottom:10px;
}

.UniversalProductModal_addMoreBtn__qiPhm{
  padding-left: 10px;
  height:44px;
  border-radius:12px;
  border:0;
  background:rgba(29,135,82,1);
  color:#fff;
  cursor:pointer;
  font-weight:900;
  font-size:14px;
}
.UniversalProductModal_addMoreBtn__qiPhm:hover{ 
    filter:brightness(.95); 
}

.UniversalProductModal_saveBtn__sY9x1{
  padding-left: 10px;
  height:44px;
  border-radius:12px;
  border:0;
  background:#111;
  color:#fff;
  cursor:pointer;
  font-weight:900;
  font-size:14px;
}
.UniversalProductModal_saveBtn__sY9x1:hover{ filter:brightness(.95); }

.UniversalProductModal_cancelBtn__sOiTk{
  text-align: center;
  width:100%;
  height:42px;
  border-radius:12px;
  border:1px solid rgba(0,0,0,.12);
  background:#fff;
  color:#111;
  cursor:pointer;
  font-weight:800;
}
.UniversalProductModal_cancelBtn__sOiTk:hover{ background:rgba(0,0,0,.03); }

.UniversalProductModal_hint__7XgQd{
  margin-top:10px;
  display:flex;
  justify-content:center;
  align-items:center;
  gap:6px;
  font-size:12px;
  color:rgba(0,0,0,.60);
}
.UniversalProductModal_dot__qqioo{ opacity:.55; }
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/UniversalProductModal.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,OAAO;EACP,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,sBAAsB,MAAM,aAAa;EACzC,eAAe;EACf,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,QAAQ;EACR,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;AACA,8CAAiB,0BAA0B,EAAE;;AAE7C;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,QAAM;EACN,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,UAAU;EACV,iBAAiB,EAAE,kBAAkB;EACrC,aAAa;AACf;;AAEA;EACE,QAAM;EACN,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;AACA,6CAAgB,sBAAsB,EAAE;;AAExC;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW,eAAe,WAAW;EACrC,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,cAAc;EACd,YAAY,cAAc,qBAAqB;EAC/C,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,UAAU;EACV,wBAAgB;UAAhB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,6CAAgB,yBAAyB,EAAE;;AAE3C;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;IACI,sBAAsB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,UAAU;EACV,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA,6CAAgB,sBAAsB,EAAE;;AAExC;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,UAAU;EACV,cAAc;EACd,eAAe;AACjB;AACA,+CAAkB,0BAA0B,EAAE;;AAE9C;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,cAAc;EACd,qBAAqB;AACvB;AACA,mCAAM,WAAW,EAAE","sourcesContent":[".overlay{\n  position:fixed;\n  inset:0;\n  background:rgba(0,0,0,.45);\n  display:flex;\n  align-items:center;\n  justify-content:center;\n  padding:14px;\n  z-index:9999;\n}\n\n.modal{\n  width:min(360px, 94vw);     /* ✅ меньше */\n  background:#fff;\n  border-radius:14px;\n  box-shadow:0 18px 50px rgba(0,0,0,.22);\n  padding:12px;\n  border:1px solid rgba(0,0,0,.06);\n}\n\n.header{\n  display:flex;\n  align-items:center;\n  justify-content:space-between;\n  gap:10px;\n  padding:4px 4px 10px 4px;\n}\n\n.title{\n  font-size:16px;\n  font-weight:800;\n  color:#111;\n}\n\n.closeBtn{\n  width:34px;\n  height:34px;\n  border-radius:10px;\n  border:1px solid rgba(0,0,0,.10);\n  background:#fff;\n  cursor:pointer;\n  display:grid;\n  place-items:center;\n  color:#111;\n}\n.closeBtn:hover{ background:rgba(0,0,0,.04); }\n\n.field{\n  margin-bottom:10px;\n}\n\n.fieldBox{\n  display:flex;\n  align-items:center;\n  gap:10px;\n  border:1px solid rgba(0,0,0,.12);\n  border-radius:12px;\n  padding:10px 10px 10px 12px;\n  background:#fff;\n}\n\n.fieldBox:focus-within{\n  border-color:rgba(29,135,82,.70);\n  box-shadow:0 0 0 4px rgba(29,135,82,.10);\n}\n\n.priceInput{\n  flex:1;\n  border:0;\n  outline:0;\n  background:transparent;\n  font-size:22px;\n  font-weight:900;\n  color:#111;\n  text-align:center; /* ✅ центр суммы */\n  line-height:1;\n}\n\n.textInput{\n  flex:1;\n  border:0;\n  outline:0;\n  background:transparent;\n  font-size:14px;\n  color:#111;\n}\n\n.textInput::placeholder{\n  color:rgba(0,0,0,.45);\n}\n\n.iconBtn{\n  width:34px;\n  height:34px;\n  border-radius:10px;\n  border:0;\n  background:rgba(29,135,82,.12);\n  color:rgba(29,135,82,1);\n  cursor:pointer;\n  display:grid;\n  place-items:center;\n}\n.iconBtn:hover{ filter:brightness(.95); }\n\n.iconStatic{\n  width:34px;\n  height:34px;\n  border-radius:10px;\n  background:rgba(0,0,0,.06);\n  color:rgba(0,0,0,.72);\n  display:grid;\n  place-items:center;\n}\n\n.keypad{\n  display:grid;\n  grid-template-columns:repeat(3, 1fr);\n  gap:10px;\n  margin:12px 0 14px;\n}\n\n.keyBtn{\n  height:50px;              /* ✅ ниже */\n  border-radius:12px;\n  border:1px solid rgba(0,0,0,.10);\n  background:rgba(0,0,0,.03);\n  cursor:pointer;\n  display:grid;             /* ✅ центр символов */\n  place-items:center;\n  font-size:18px;\n  font-weight:900;\n  color:#111;\n  user-select:none;\n}\n\n.keyBtn:hover{\n  background:rgba(29,135,82,.10);\n  border-color:rgba(29,135,82,.25);\n}\n\n.keyBtn:active{ transform:translateY(1px); }\n\n.keyBtnBackspace{\n  background:rgba(0,0,0,.06);\n}\n\n.actionsRow{\n  display:grid;\n  grid-template-columns:1fr 1fr;\n  gap:10px;\n  margin-bottom:10px;\n}\n\n.addMoreBtn{\n  padding-left: 10px;\n  height:44px;\n  border-radius:12px;\n  border:0;\n  background:rgba(29,135,82,1);\n  color:#fff;\n  cursor:pointer;\n  font-weight:900;\n  font-size:14px;\n}\n.addMoreBtn:hover{ \n    filter:brightness(.95); \n}\n\n.saveBtn{\n  padding-left: 10px;\n  height:44px;\n  border-radius:12px;\n  border:0;\n  background:#111;\n  color:#fff;\n  cursor:pointer;\n  font-weight:900;\n  font-size:14px;\n}\n.saveBtn:hover{ filter:brightness(.95); }\n\n.cancelBtn{\n  text-align: center;\n  width:100%;\n  height:42px;\n  border-radius:12px;\n  border:1px solid rgba(0,0,0,.12);\n  background:#fff;\n  color:#111;\n  cursor:pointer;\n  font-weight:800;\n}\n.cancelBtn:hover{ background:rgba(0,0,0,.03); }\n\n.hint{\n  margin-top:10px;\n  display:flex;\n  justify-content:center;\n  align-items:center;\n  gap:6px;\n  font-size:12px;\n  color:rgba(0,0,0,.60);\n}\n.dot{ opacity:.55; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `UniversalProductModal_overlay__CYJXt`,
	"modal": `UniversalProductModal_modal__doWhy`,
	"header": `UniversalProductModal_header__LTQvV`,
	"title": `UniversalProductModal_title__TxkF4`,
	"closeBtn": `UniversalProductModal_closeBtn__dkABv`,
	"field": `UniversalProductModal_field__ohGAE`,
	"fieldBox": `UniversalProductModal_fieldBox__DdcWM`,
	"priceInput": `UniversalProductModal_priceInput__5Glxw`,
	"textInput": `UniversalProductModal_textInput__8QmoN`,
	"iconBtn": `UniversalProductModal_iconBtn__DCn6q`,
	"iconStatic": `UniversalProductModal_iconStatic__MWm30`,
	"keypad": `UniversalProductModal_keypad__CWGG5`,
	"keyBtn": `UniversalProductModal_keyBtn__GaRRc`,
	"keyBtnBackspace": `UniversalProductModal_keyBtnBackspace__kcMNu`,
	"actionsRow": `UniversalProductModal_actionsRow__PJmJZ`,
	"addMoreBtn": `UniversalProductModal_addMoreBtn__qiPhm`,
	"saveBtn": `UniversalProductModal_saveBtn__sY9x1`,
	"cancelBtn": `UniversalProductModal_cancelBtn__sOiTk`,
	"hint": `UniversalProductModal_hint__7XgQd`,
	"dot": `UniversalProductModal_dot__qqioo`
};
export default ___CSS_LOADER_EXPORT___;
